import {createSelector} from "@reduxjs/toolkit";

const baseState = state => state.comments.vote;

export const voteCommentErrorSelector = createSelector([baseState], (state) => {
    return state.error;
});
export const voteCommentLoadingSelector = createSelector([baseState], (state) => {
    return state.status;
});